import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d5cc1154"
import script from "./Index.ts?vue&type=script&lang=ts&external"
export * from "./Index.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports